export const ALL_DIMENSIONS = [
  'Date',
  'Screen Name',
  'Geo (city)',
  'Screen size',
  'Campaign Name',
  'Creative length',
  'Creative format',
  'Creative Name',
  'Creative Folder Name',
] as const;

export const ALL_METRICS = ['Screen Uptime (%)', 'Impressions'] as const;
